import { Redirect } from 'expo-router';

import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import { Referrals } from '../../referrals/components/Referrals';

const ReferralsPage = () => {
    const user = useAuthedUser();

    if (user.referralCode === undefined) {
        return <Redirect href="/" />;
    }

    return (
        <Referrals
            referralCode={user.referralCode}
            currentYearReferralCount={user.currentYearReferralCount ?? 0}
        />
    );
};

export default ReferralsPage;
